import { RootStore } from 'store/rootStore';
import { makeAutoObservable, runInAction } from 'mobx';
import { File, PdfResultV2Status } from 'types/policyService';
import { getPolicyByEnrollmentPeriodId } from 'api/operations/policyService';
import { retryRequestFor } from 'global/utils/retryRequestFor';
import { downloadByUrl } from '@insurancemenu/imenu-components-lib/dist/helpers/downloadByUrl';
import { downloadFileByLink } from 'global/utils/downloadFileByLink';
import { COMMON_URLS } from '@insurancemenu/imenu-components-lib/dist/utils/urls';

const initialFile: File = {
  id: '',
  name: '',
  creationDate: '',
  status: PdfResultV2Status.COMPLETED,
  signatureRequestDate: '',
};

export class SummaryTableStore {
  rootStore: RootStore;
  outputFiles: File[] = [];
  finalCsvZip: File = initialFile;
  loading = true;
  isWarningModalOpen = false;

  public get creationDate(): string {
    return (this.outputFiles.length > 0 && this.outputFiles[0].creationDate) || '';
  }

  // eslint-disable-next-line class-methods-use-this
  public downloadCsvFile(id: string, name: string): void {
    const downloadLink = `https://${COMMON_URLS.api}/csvBinary/Prod/download/${id}`;
    downloadFileByLink(name, downloadLink);
  }

  public setLoading(status: boolean): void {
    this.loading = status;
  }

  public async buildSummaryList(periodId: string): Promise<void> {
    this.updateModalShowStatus(false);
    this.outputFiles = [];
    this.setLoading(true);

    try {
      const policy = await retryRequestFor(() => getPolicyByEnrollmentPeriodId(periodId), 10000, 2000);
      runInAction(() => {
        this.outputFiles = policy.outputFiles;
        this.finalCsvZip = policy.finalCsvZip;
      });
    } catch (error) {
      this.updateModalShowStatus(true);
    } finally {
      this.setLoading(false);
    }
  }

  updateModalShowStatus(showStatus: boolean): void {
    this.isWarningModalOpen = showStatus;
  }

  public downloadFinalZip(): void {
    if (this.finalCsvZip.id) {
      const downloadLink = `https://${COMMON_URLS.api}/csvBinary/Prod/download/${this.finalCsvZip.id}`;
      downloadByUrl(downloadLink);
    }
  }

  public resetData(): void {
    this.outputFiles = [];
    this.finalCsvZip = initialFile;
    this.setLoading(true);
    this.updateModalShowStatus(false);
  }

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
    makeAutoObservable(this, {}, { autoBind: true });
  }
}
